import { useEffect, useState } from "react";
import { LoaderCircle, X } from "lucide-react";

export default function OrderTransitionModal({ action, isSaving, onClose, onSubmit }) {
  const [note, setNote] = useState("");
  const [amount, setAmount] = useState("");
  const [allowUnpaid, setAllowUnpaid] = useState(false);

  useEffect(() => {
    setNote("");
    setAmount("");
    setAllowUnpaid(false);
  }, [action?.key]);

  if (!action) return null;

  function submit(event) {
    event.preventDefault();
    const payload = {};
    if (action.needsNote) payload.note = note;
    if (action.needsRefund) {
      payload.amount = amount;
      payload.reason = note;
    }
    if (action.needsAllowUnpaid) payload.allow_unpaid = allowUnpaid;
    onSubmit(action, payload);
  }

  return (
    <div className="admin-modal-backdrop">
      <form className="order-transition-modal" onSubmit={submit}>
        <header>
          <div>
            <span className="admin-eyebrow">Order action</span>
            <h2>{action.label}</h2>
          </div>
          <button type="button" className="order-modal-close" onClick={onClose} disabled={isSaving} aria-label="Close order action">
            <X size={20} />
          </button>
        </header>

        {action.description && <p>{action.description}</p>}
        {action.needsRefund && <label>Refund amount<input required type="number" min="0.01" step="0.01" value={amount} onChange={(event) => setAmount(event.target.value)} /></label>}
        {(action.needsNote || action.needsRefund) && <label>{action.needsRefund ? "Reason" : "Note"}<textarea rows="4" value={note} onChange={(event) => setNote(event.target.value)} /></label>}
        {action.needsAllowUnpaid && <label className="order-checkbox"><input type="checkbox" checked={allowUnpaid} onChange={(event) => setAllowUnpaid(event.target.checked)} /> Allow delivery before payment is marked paid</label>}

        <footer>
          <button type="button" className="btn btn--secondary" onClick={onClose} disabled={isSaving}>Cancel</button>
          <button type="submit" className={action.danger ? "btn admin-danger-button" : "btn"} disabled={isSaving || (action.needsRefund && !amount)}>
            {isSaving && <LoaderCircle size={16} className="admin-spin" />}
            {isSaving ? "Working..." : action.label}
          </button>
        </footer>
      </form>
    </div>
  );
}
